import { DEFAULT_BASE_ASSET } from '@/shared/config';
import { ASSET_PRICES_FILTER, type AssetPricesFilter } from '@/shared/types';

export const MARKET_TABS = {
  popular: 'popular',
  new: 'new',
  gainers: 'gainers',
  losers: 'losers',
} as const;

export type MarketTab = keyof typeof MARKET_TABS;

export const MARKET_TAB_FILTER: Record<MarketTab, AssetPricesFilter> = {
  popular: ASSET_PRICES_FILTER.hot,
  new: ASSET_PRICES_FILTER.new,
  gainers: ASSET_PRICES_FILTER.gainers,
  losers: ASSET_PRICES_FILTER.losers,
};

export const MARKET_TABS_ORDER: Array<MarketTab> = [
  MARKET_TABS.popular,
  MARKET_TABS.new,
  MARKET_TABS.gainers,
  MARKET_TABS.losers,
];

export const MARKET_BASE_ASSET = DEFAULT_BASE_ASSET;

export const MARKET_ASSETS_QTY = 5;

export const MARKET_CHART_PERIOD = '1d';
